import React, { ReactElement, useState } from "react";
import { List } from "immutable";
import { Field, useForm, useTextField } from "./Form";
import Button from "@material-ui/core/Button";
import Table from "./Table";
import Th from "./Th";
import FieldContainer from "./Field";
import Grid from "@material-ui/core/Grid";

export const maxTitulos = 10;

export type Titulo = {
  id: number;
  titulo: string;
  institucion: string;
  reactKey: string;
};

export function useTitulosField(props): Field<List<Titulo>> {
  const defaultValue = props.defaultValue
    ? props.defaultValue.map((val) => {
        return { ...val, reactKey: val.id };
      })
    : [];
  const defaultTitulos = props.defaultValue
    ? List.of(...defaultValue)
    : List<Titulo>();
  const [titulos, setTitulos] = useState(defaultTitulos);
  const value = titulos;

  const tituloGradoField = useTextField({
    fullWidth: true,
    label: "Título/Grado",
  });
  const institucionField = useTextField({
    fullWidth: true,
    label: "Institución",
  });

  const innerForm = useForm([tituloGradoField, institucionField]);

  function validate(): string {
    if (titulos.isEmpty()) {
      return "Debe agregar al menos un título/grado";
    } else if (titulos.size > maxTitulos) {
      return `Se permite un máximo de ${maxTitulos} título/grados`;
    } else {
      return "OK";
    }
  }

  const validation = validate();
  const valid = validation === "OK";

  function addTitulo(): void {
    const newTitulo = {
      id: -1,
      titulo: tituloGradoField.value,
      institucion: institucionField.value,
      reactKey: Math.random().toString(),
    };
    setTitulos((list) => list.push(newTitulo));
    tituloGradoField.reset();
    institucionField.reset();
  }

  function removeTitulo(index: number): void {
    setTitulos((list) => list.remove(index));
  }

  function render(): ReactElement {
    return (
      <React.Fragment>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={true}>
            <FieldContainer>{tituloGradoField.render()}</FieldContainer>
          </Grid>
          <Grid item xs={true}>
            <FieldContainer>{institucionField.render()}</FieldContainer>
          </Grid>
          <Grid item xs={"auto"}>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              disabled={!innerForm.isValid}
              onClick={addTitulo}
            >
              Agregar
            </Button>
          </Grid>
        </Grid>

        <div className="mt-3">
          <Table>
            <thead>
              <tr>
                <Th>N</Th>
                <Th>Título/Grado</Th>
                <Th>Institución</Th>
                <Th>Acciones</Th>
              </tr>
            </thead>

            <tbody>
              {titulos.map((titulo, index) => (
                <tr key={titulo.reactKey + `-${index}`}>
                  <td>{index + 1}</td>
                  <td>{titulo.titulo}</td>
                  <td>{titulo.institucion}</td>
                  <td className="py-1">
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      disableElevation
                      onClick={() => removeTitulo(index)}
                    >
                      Eliminar
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {!valid && <div>{validation}</div>}
      </React.Fragment>
    );
  }

  return { value, validation, valid, render };
}
